// 🔧 index.js
// ✅ Purpose: Entry point for the Passport Demo Engine
// ✅ Features:
// - Exposes runPassportEngine()
// - Runs Passport Builder when Passport is selected
// - Builds adaptive engagement stops from Core + selected add-ons
// - Returns standardized Demo Report v2-compatible results
// - Fully block-commented for clarity and future devs

import { buildPassport } from "./passport_builder";

export const runPassportEngine = async ({ demoContext } = {}) => {
  console.log("🛂 Passport Engine started.");

  const result = await buildPassport({ demoContext });

  console.log("✅ Passport Engine completed.", { result });

  return result;
};